<template>

    <!-- Encabezado de la Aplicación -->
    <div class="appHeader no-border">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            Configuración FA2
        </div>
        <div class="right">
            <a href="#" class="headerButton" data-bs-toggle="modal" data-bs-target="#DialogBasic">Ayuda</a>
        </div>
    </div>
    <!-- * Encabezado de la Aplicación -->

    <!-- Cápsula de la aplicación -->
    <div id="appCapsule">

        <div class="section mt-2 text-center">
            <h1>Configurar Doble Factor</h1>
            <h4>Escanea el código en tu aplicacion FA2 (Doble Factor) y pulsa el botón continuar para verificar la Configuración.</h4>
        </div>

        <div class="section">
            <div class="splash-page mt-5 mb-5">
                <div class="mb-3">
                    <img :src="codeQR" alt="Código QR" class="imaged square w320">
                </div>
                <h2 class="mb-2">Escanea el Código QR</h2>
                <p>Recuerda permitir los permisos necesarios.</p>
            </div>
        </div>

        <div class="section mb-5 p-2">
            <form @submit.prevent="submitForm">

                <div class="form-button-group transparent">
                    <button type="submit" class="btn btn-primary btn-block btn-lg">Confirmar numero</button>
                </div>

            </form>
        </div>

    </div>
    <!-- * Cápsula de la aplicación -->

    <!-- Diálogo Básico -->
    <div class="modal fade dialogbox" id="DialogBasic" data-bs-backdrop="static" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Verificación de Código QR</h5>
                </div>
                <div class="modal-body">
                    Puede usar la verificación de código QR para la autenticación de dos factores o proteger acciones.
                </div>
                <div class="modal-footer">
                    <div class="btn-inline">
                        <a href="#" class="btn btn-text-primary" data-bs-dismiss="modal">OK</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Diálogo Básico -->


</template>

<script>
import { mapState, mapActions } from 'vuex';
import QRCode from 'qrcode'
export default {
    data() {
        return {
            sid: null,
            binding: {
                secret: null,
                uri: null
            },
            url: null,
            codeQR: null,
        };
    },
    computed: {
        ...mapState(['userData']),
    },
    methods: {
        ...mapActions(['validateFA2API']),
        async submitForm() {
            console.log('submitForm')
            const res = await this.validateFA2API({})
            console.log('submitForm:res', res)
            
            if (res.status == "unverified") {
                location.replace("/validate-fa2")
            }
            // if (res == true) {
            //     location.replace("/validate-mobile")
            // }
        }
    },
    async mounted() {
        let self = this
        self.$root.loadBackButtom();
        if (this.userData.binding != null) {
            // location.replace("/validate-fa2")
        }
        const res = await this.validateFA2API({})
        console.log('mounted:res', res)
        console.log('mounted:res:res.binding.uri', res.binding.uri)

        if (res.binding.uri != undefined) {
            // With promises
            // QRCode.toDataURL('I am a pony!')
            // .then(url => {
            //     console.log(url)
            // })
            // .catch(err => {
            //     console.error(err)
            // })

            // console.log('generateQR', generateQR)
            try {
                this.codeQR = await QRCode.toDataURL(res.binding.uri)
            } catch (err) {
                console.error(err)
                this.codeQR = '@/assets/img/sample/qr.png'
            }
        }
    }
}
</script>